import React from 'react';
import Icon from 'components/DesignSystem/Icon';
import { Read, readIconColor } from 'helper/mailer';
import { cssVar } from 'constants/theme';
import './index.scss';

export default function EmailRead({ readInfo }: {
  readInfo: Read,
}) {
  const requestData: object | undefined = readInfo.requestData ? JSON.parse(readInfo.requestData.replace(/"/g, '\\"').replace(/'/g, '"')) : undefined;
  const date = new Date(readInfo.requestDate * 1000);

  return (
    <div className="email-read-text">
      <div>
        <Icon
          className="email-read-icon"
          iconType="lan"
          size="small"
          color={cssVar('text-accent')}
        />
        <span className="me-1">{readInfo.ipAddress}</span>
        <Icon
          className="ms-1"
          iconType="visible"
          size="small"
          color={readIconColor(requestData, 'click')}
        />
        <Icon
          className="ms-1"
          iconType="visible"
          size="small"
          color={readIconColor(requestData)}
        />
        <Icon
          className="ms-1"
          iconType="file"
          size="small"
          color={readIconColor(requestData, 'download-file')}
        />
      </div>
      <div>
        <Icon
          className="email-read-icon"
          iconType="calendar"
          size="small"
          color={cssVar('text-accent')}
        />
        <span>{date.toLocaleDateString('pt-BR')}</span>
        <span className="ms-2">{date.toLocaleTimeString('pt-BR')}</span>
      </div>
    </div>
  );
}
